import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getActivityLogsForUserProjectDate } from '../services/getActivityLogsForUserProjectDate.service';

export const fetchActivityLogsForUserProjectDate = createAsyncThunk(
  'activityLog/fetchForUserProjectDate',
  async ({ projectId, userId, date }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const data = await getActivityLogsForUserProjectDate({
      projectId,
      userId,
      date,
      activeEmployerInfo,
    });

    return data?.items || [];
  }
);
